import { logError } from "helpers/rxjs-operators/logError";
import { enRoles } from "interfaces/models/core/user/user";
import { memo, PropsWithChildren, useEffect } from "react";
import { useObservable } from "react-use-observable";
import { useNavigate } from "react-router-dom";
import authService from "services/auth";

interface IProps extends PropsWithChildren {
  passIfNull?: boolean;
  role?: enRoles | enRoles[];
  inverse?: boolean;
}

const PermissionHide = memo((props: IProps) => {
  const navigate = useNavigate();
  const [canAccess] = useObservable(() => {
    const roles = Array.isArray(props.role)
      ? props.role
      : props.role
        ? [props.role]
        : [];
    return authService.canAccess(...roles).pipe(logError());
  }, [props.role]);

  useEffect(() => {
    if (canAccess === false) {
      navigate("/login");
    }
  }, [canAccess, navigate]);

  if (canAccess === undefined || canAccess === null) {
    return null;
  }

  if (props.inverse && !canAccess) {
    return props.children as any;
  }

  if (props.inverse || !canAccess) {
    return null;
  }

  return props.children as any;
});

export default PermissionHide;
